import { FilterConfig } from '../filterConfigs/FilterConfig';
import { generateFilter, FilterPreset } from '../filterConfigs/filterGenerators';

type Result = { id: string; name: string; count: number };
/** @deprecated Use new filter format in filterGenerators.ts instead **/
const visitFilter = (field: string): FilterConfig<Result> => generateFilter(FilterPreset.Visit, { field });

export default visitFilter;
